var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLinkAccount3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17.5C5 10.5964 10.5964 5 17.5 5H42.5C49.4036 5 55 10.5964 55 17.5V42.5C55 49.4036 49.4036 55 42.5 55H17.5C10.5964 55 5 49.4036 5 42.5V17.5ZM17.5 10C13.3579 10 10 13.3579 10 17.5V42.5C10 46.6421 13.3579 50 17.5 50H42.5C46.6421 50 50 46.6421 50 42.5V17.5C50 13.3579 46.6421 10 42.5 10H17.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2678 20.7322C40.2441 21.7085 40.2441 23.2915 39.2678 24.2678L24.2678 39.2678C23.2915 40.2441 21.7085 40.2441 20.7322 39.2678C19.7559 38.2915 19.7559 36.7085 20.7322 35.7322L35.7322 20.7322C36.7085 19.7559 38.2915 19.7559 39.2678 20.7322Z",
    fill: "#F4C843"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 36.25C40 38.3211 38.3211 40 36.25 40C34.1789 40 32.5 38.3211 32.5 36.25C32.5 34.1789 34.1789 32.5 36.25 32.5C38.3211 32.5 40 34.1789 40 36.25Z",
    fill: "#F4C843"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 23.75C27.5 25.8211 25.8211 27.5 23.75 27.5C21.6789 27.5 20 25.8211 20 23.75C20 21.6789 21.6789 20 23.75 20C25.8211 20 27.5 21.6789 27.5 23.75Z",
    fill: "#F4C843"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLinkAccount3);
export default __webpack_public_path__ + "static/media/new-link-account-3.6df596c0dc0ba8152bc6ee24b0944269.svg";
export { ForwardRef as ReactComponent };